module.exports = __webpack_public_path__ + "img/rule_content.46087b3d.png";